// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error - @dw/js-sdk module lacks type definitions
import WebReporter from '@dw/js-sdk/dist/WebReporter.js'

let dw: GlobalAny = null
// wps_photo_web https://365.kdocs.cn/l/cp4TDdzoqekB
const APP_KEY = '32de449f6e37112a'

const isDebugMode = false

function getFromSource(): string {
  try {
    const params = new URLSearchParams(window.location.search)
    return params.get('from') || ''
  } catch {
    return ''
  }
}

let cachedFrom: string | undefined
function getFrom(): string {
  if (cachedFrom === undefined) {
    cachedFrom = getFromSource()
  }
  return cachedFrom
}

/**
 * 初始化数据sdk
 */
const setupReport = () => {
  if (!dw) {
    dw = new WebReporter()
  }

  // 设置应用的唯一标识 APP_KEY
  dw.setAppKey(APP_KEY)

  // 设置调试模式, debug 为布尔类型. 如果设置成 true, 表示为调试模式. 设置成调试模式后, 从平台上开启调试, 可以看到数据实时上报 注意: 正式上线后调试模式必须改为 false, 否则数据不会入正式库
  dw.setDebug(isDebugMode) // 正式上线后调试模式必须改为 false, 否则数据不会入正式库


  // 设置统计渠道号, channel 为字符串类型
  // dw.setChannel('your channel')

  // dw initialized
}

/**
 * 数据上报
 * @param event 事件名
 * @param params 参数
 */
const dataReport = (event: string, params: Record<string, GlobalAny>) => {
  if (!dw) {
    console.error('dw is not defined')
    return
  }
  isDebugMode &&
    console.log(
      `%cDataReport%c${event}`,
      'background: #35495e; color: #fff; padding: 2px 8px; border-radius: 4px 0 0 4px;',
      'background: #41b883; color: #fff; padding: 2px 8px; border-radius: 0 4px 4px 0;',
      params,
    )
  const from = getFrom()
  const merged = from ? { ...params, src: from } : params
  dw.onEvent(event, merged)
}

const setAccountId = (accountId: string) => {
  if (!dw) return
  dw.setAccountId(accountId)
}

// 事件名常量
export const ReportEvent = {
  SHOW: 'photo_ai_video_show',
  CLICK: 'photo_ai_video_click',
  RESULT: 'photo_ai_video_result',
  USE: 'photo_ai_video_use',
} as const

// 事件 ID 常量
export const EventId = {
  SHOW: 51045,
  CLICK: 51046,
  RESULT: 51047,
  USE: 51048,
} as const

// 便捷方法
export function reportShow(pageName: string, src?: string) {
  dataReport(ReportEvent.SHOW, {
    event_id: EventId.SHOW,
    page_name: pageName,
    ...(src ? { src } : {}),
  })
}

export function reportClick(pageName: string, buttonName: string, extra?: Record<string, GlobalAny>) {
  dataReport(ReportEvent.CLICK, {
    event_id: EventId.CLICK,
    page_name: pageName,
    button_name: buttonName,
    ...extra,
  })
}

export function reportResult(params: Record<string, GlobalAny>) {
  dataReport(ReportEvent.RESULT, { event_id: EventId.RESULT, ...params })
}

export function reportUse(params: Record<string, GlobalAny>) {
  dataReport(ReportEvent.USE, { event_id: EventId.USE, ...params })
}

export function getReporterInstance() {
  return dw
}

const AI_ACCESS_APP_KEY = 'f37b6da8ceddc9c7'
let aiAccessDw: GlobalAny = null

export function getAiAccessReporter() {
  if (!aiAccessDw) {
    aiAccessDw = new WebReporter()
    aiAccessDw.setAppKey(AI_ACCESS_APP_KEY)
    aiAccessDw.setDebug(isDebugMode)
  }
  return aiAccessDw
}

export { setupReport, dataReport, setAccountId }
